<template>
  <div>
    <div class="buttons" v-if="exist">
      <Button
        @click="add"
        label="まとめてリストに"
        icon="pi pi-play"
        iconPos="right"
        class="button"
      />
      <ToggleButton
        class="button"
        v-model="uniqunize"
        onLabel="もとに戻す"
        offLabel="重複を削除"
        onIcon="pi pi-plus"
        offIcon="pi pi-minus"
      />
    </div>
    <div v-if="!uniqunize">
      <template v-for="song in songList" :key="song">
        <SongCard :songId="song.id" :displayButton="true" />
      </template>
    </div>
    <div v-if="uniqunize">
      <template v-for="song in uniqueSongs" :key="song">
        <SongCard :songId="song" :displayButton="true" />
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import firebase from "../firebase/firebase";
import { useStore } from "vuex";
import SongCard from "@/components/SongCard.vue";
import ToggleButton from "primevue/togglebutton";
import Button from "primevue/button";

export default defineComponent({
  name: "SongList",
  components: { SongCard, ToggleButton, Button },
  props: {},
  setup() {
    const store = useStore();
    return { store: store, uniqunize: ref(false) };
  },
  data() {
    const songList: Array<any> = [];
    return {
      songList: songList,
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search: async function () {
      this.songList = [];
      console.log("songlist: searching...");
      const ref = firebase.firestore().collection("songs");
      if (this.queries.length > 0) {
        let target = ref.where("tag", "array-contains", this.queries[0]);
        await target.get().then((querySnapshot) => {
          console.log(querySnapshot);
          querySnapshot.forEach((doc) => {
            this.songList.push({ id: doc.id, data: doc.data() });
          });
        });
        console.log("中間");
        for (let i = 1; i < this.queries.length; i++) {
          this.songList = this.songList.filter((song) =>
            song.data.tag.includes(this.queries[i])
          );
        }
      }
      console.log("searchend");
    },
    add() {
      if (this.uniqunize) {
        this.uniqueSongs.forEach((id: string) => {
          this.store.commit("addList", id);
        });
      } else {
        this.songList.forEach((song: any) => {
          this.store.commit("addList", song.id);
        });
      }
    },
  },
  computed: {
    queries(): Array<string> {
      return this.store.state.query.query;
    },
    uniqueSongs(): any {
      const temps: Array<any> = [];
      const read = new Set();
      this.songList.forEach((element: any) => {
        const titleTag0 = element.data.screenTitle + element.data.tag[0];
        if (read.has(titleTag0)) {
          return;
        } else {
          read.add(titleTag0);
          temps.push(element.id);
        }
      });
      console.log(read);
      return temps;
    },
    exist(): boolean {
      return this.songList.length > 0;
    },
  },
  watch: {
    queries() {
      this.search();
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.buttons {
  margin-top: 10px;
}
.button {
  margin: 3px;
}
</style>
